import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { FormDataOptions } from "src/app/models/models";

@Component({
	selector: "app-ts1-maneuver-sidebar",
	templateUrl: "./ts1-maneuver-sidebar.component.html",
	styleUrls: ["./ts1-maneuver-sidebar.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class Ts1ManeuverSidebarComponent {
	readonly dragStartDelay = 400;

	@Input() maneuvers!: UntypedFormArray;
	@Input() activeIndex = 0;
	@Input() readOnly = false;
	@Output() activeIndexChange = new EventEmitter<number>();
	@Output() removeManeuver = new EventEmitter<number>();
	@Output() addManeuver = new EventEmitter<void>();

	getManeuverLabel(maneuverForm: UntypedFormGroup): string {
		const v = maneuverForm.get("maneuver")?.value;
		if (!v) return "New Maneuver";
		if (typeof v === "string") return v;
		return (v as FormDataOptions).description ?? (v as FormDataOptions).code ?? "Maneuver";
	}

	select(index: number): void {
		this.activeIndexChange.emit(index);
	}

	onRemove(event: Event, index: number): void {
		if (this.readOnly) return;
		event.stopPropagation();
		this.removeManeuver.emit(index);
	}

	onAddClick(event: Event): void {
		if (this.readOnly) return;
		event.preventDefault();
		event.stopPropagation();
		this.addManeuver.emit();
	}

	onDropManeuver(event: CdkDragDrop<any[]>): void {
		if (this.readOnly) return;
		const prev = event.previousIndex;
		const curr = event.currentIndex;
		if (prev === curr) return;

		const ctrl = this.maneuvers.at(prev);
		this.maneuvers.removeAt(prev);
		this.maneuvers.insert(curr, ctrl);
		this.maneuvers.updateValueAndValidity({ onlySelf: true });

		const nextActiveIndex = this.resolveActiveIndexAfterReorder(prev, curr);
		if (nextActiveIndex !== this.activeIndex) {
			this.activeIndex = nextActiveIndex;
		}
		this.activeIndexChange.emit(this.activeIndex);
	}

	private resolveActiveIndexAfterReorder(previousIndex: number, currentIndex: number): number {
		if (this.activeIndex === previousIndex) {
			return currentIndex;
		}
		if (previousIndex < this.activeIndex && currentIndex >= this.activeIndex) {
			return this.activeIndex - 1;
		}
		if (previousIndex > this.activeIndex && currentIndex <= this.activeIndex) {
			return this.activeIndex + 1;
		}
		return this.activeIndex;
	}
}
